import React from 'react';
import { Input, Button, Select, Viewer, Modal, Pagination, Tooltip, DatePicker } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { connect } from 'react-redux';
import { EditIcon, AlertIcon, RebuildIcon, Menu as MenuIcons, User2Icon, PaperIcon, PencilIcon, TimeIcon, Calendar, AlertCircleIcon, WarningIcon } from 'assets/icons';
import moment from 'moment';
import { ReportService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class ViewVerification extends React.Component<Props> {

	state = {
		verification: null,
		file: null,
		visible: false,
		session: null,
		page: 1,
		last_page: 1,
		first_load: true,
		is_edit: false,
		original_verification: null,
		visible_reupload: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Ver verificación',
				subtitle: 'Consulta y revisa todas las facturas realizadas en el sistema.',
				color: '#edf0fe',
				icon: MenuIcons.Menu6,
				onBack: () => {
					this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/bills/report');
				}
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		// @ts-ignore
		const session: number = this.props.match?.params?.id;

		if (!session) {
			this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/bills/report');
		}

		const res: any = await ReportService.admin.bills.view({
			session,
			page: this.state.page,
			withoutLoading,
			first_load: this.state.first_load
		});
		if (!res.session || (res.session?.user_id !== this.props.user?.id && res.session?.user_id !== this.props.user?.user_id && (this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR))) {
			this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/bills/report');
			return;
		}
		const record = res.verifications.rows.length > 0 ? res.verifications.rows[0] : null;
		this.setState({
			verification: record ? { ...record } : null, 
    		original_verification: record ? { ...record } : null,
			session: res.session,
			last_page: res.verifications.count,
			first_load: false,
			page: this.state.first_load ? res.verifications.count : this.state.page,
			is_edit: false
		});
	}

	setVisible = (value: boolean) => {
		this.setState({
			visible: value
		});
	}

	view = (url: string) => {
		this.setState({
			visible: true,
			file: url
		});
	}
	
	onClose = () => {
		this.setState({
			visible_modal: false,
			type: null
		},() => this.load());
	}

	getColor = () => {
		// @ts-ignore
		if (this.state.verification?.result) {
			return Colors.green;
		}
		else {
			return Colors.danger;
		}
	}

	change = (e: any) => {
	    const { name, value } = e.target;
	    
	    this.setState({
	        verification: {
	        	// @ts-ignore
	            ...this.state.verification,
	            [name]: value
	        }
	    });
	}

	changeDetail = (e: any, index: number) => {
	    const { name, value } = e.target;

	    this.setState((prevState: any) => ({
	        verification: {
	            ...prevState.verification,
	            details: prevState.verification.details.map((item: any, i: number) => {
	                if (i === index) {
	                    return { ...item, [name]: value };
	                }
	                return item;
	            })
	        }
	    }));
	}

	save = async () => {
		// @ts-ignore
		if (!Globals.validateTime(this.state.verification?.hour)) {
			Globals.showWarning("La hora no es válida");
			return;
		}

		const res: any = await ReportService.admin.bills.save({
			verification: JSON.stringify(this.state.verification)
		});
		Globals.showSuccess("Se ha editado la factura correctamente");
		if (res.verification) {
			this.setState({
				is_edit: false,
				verification: { ...res.verification },
				original_verification: { ...res.verification },
			});
		}
	}

	onCloseReupload = async (first_load = false) => {
		if (first_load) {
			await this.setState({
				first_load: true
			});
		}

		this.setState({
			visible_reupload: false
		},() => {
			this.load(true);
		});
	}

	render() {
		const verification: any = this.state.verification;
		const session: any = this.state.session;
		const { visible, is_edit, visible_reupload } = this.state;
		const has_code = verification?.details?.find((i: any) => i.code != null) != null;
		const real_subtotal = parseFloat((verification?.details?.map((i: any) => i.price * i.quantity).reduce((a: number, b: number) => a + b,0))?.toFixed(2));
		const is_diff_products = verification?.details?.find((i: any) => i.total != (i.price * i.quantity));
		const is_diff_subtotal = verification?.subtotal != real_subtotal;
		const real_total = parseFloat((parseFloat(verification?.subtotal) + (parseFloat(verification?.iva) || 0) + (parseFloat(verification?.igtf) || 0))?.toFixed(2));
		const is_diff_total = verification?.total != real_total;

		return (
			<div id="view-bill">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setVisible(false) }
			      images={ [{ src: this.state.file }] }
			    />

		      	<div className="row">
		      		<div className="col-md-6 text-center" style={{ marginBottom: '8px' }}>
		      			<p className="id-usuario">ID Sesión: { session?.value }</p>
		      		</div>
		      		{
		      			this.state.last_page > 1 && (
		      				<div className="col-md-6 text-right">
				      			<Pagination 
				      				inverse={ true }
									pages={ this.state.last_page } 
									active={ this.state.page }
									onChange={ async (page: number) => {
										await this.setState({
											page: page
										});
										this.load();
									} } />
							</div>
		      			)
		      		}
		      	</div>
				<div className="row">
					<div className="col-md-6">
						{
							(is_diff_products || is_diff_subtotal || is_diff_total) && (
								<div className="container-warning">
									<img src={ WarningIcon } />
									<div>
										<h6>Detectamos inconsistencias en los cálculos de la factura</h6>
										<p>{ (verification?.total > 0 || verification?.details?.length > 0) ? 'Revisa los valores resaltados antes de continuar' : 'La factura no es válida' }</p>
									</div>
								</div>
							)
						}
						{
							(verification?.total > 0 || verification?.details?.length > 0) && (
								<div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', marginRight: '5px' }}>
									<button className="btn container-black-list" onClick={ (e: any) => {
										this.setState({
											is_edit: !this.state.is_edit,
											verification: this.state.original_verification
										});
									} }>
										<p>{ this.state.is_edit ? 'Cancelar' : 'Editar' }</p>
										<img src={ PencilIcon } />
									</button>
								</div>
							)
						}
						{
							(verification?.total > 0 || verification?.details?.length > 0) && (
								<div className="container-bill">
									<div className="container-white">
										<div className="row">
											<div className="col-md-7" style={{ display: 'flex', justifyContent: 'center' }}>
												<div className="container-title">
													<div>
														<div className="container-icon-title">
															<img src={ PaperIcon } />
														</div>
													</div>
													{
														verification?.title && (
															<h5 dangerouslySetInnerHTML={{ __html: verification?.title }} />
														)
													}
												</div>
											</div>
											<div className="col-md-5">
												{
													verification?.number && (
														<>
															{
																is_edit ? (
																	<div className="container-values-top">
																		<img src={ PaperIcon } />
																		<div>
																			<p className="bold">Factura</p> 
																			<Input
																				value={ verification?.number }
																				name="number"
																				onChange={ (e: any) => {
																					this.change(e);
																				} } />
																		</div>
																	</div>
																) : (
																	<div className="container-values-top">
																		<img src={ PaperIcon } />
																		<div>
																			<p className="bold">Factura</p> 
																			<p>{ verification?.number }</p>
																		</div>
																	</div>
																)
															}
														</>
													)
												}
												{
													verification?.date && (
														<>
															{
																is_edit ? (
																	<div className="container-values-top">
																		<img src={ Calendar } />
																		<div>
																			<p className="bold">Fecha</p> 
																			<DatePicker
																				onChange={ (text: string) => {
																					this.change({
																						target: {
																							value: text,
																							name: 'date'
																						}
																					});
																				} }
																				value={ verification?.date != null ? moment(verification?.date).toDate() : '' }
																			/>
																		</div>
																	</div>
																) : (
																	<div className="container-values-top">
																		<img src={ Calendar } />
																		<div>
																			<p className="bold">Fecha</p> 
																			<p>{ moment(verification?.date).format('DD-MM-YYYY') }</p>
																		</div>
																	</div>
																)
															}
														</>
													)
												}
												{
													verification?.hour && (
														<>
															{
																is_edit ? (
																	<div className="container-values-top">
																		<img src={ TimeIcon } />
																		<div>
																			<p className="bold">Hora</p> 
																			<Input
																				type="hour"
																				value={ verification?.hour }
																				name="hour"
																				className="form-group-date"
																				onChange={ (e: any) => {
																					this.change(e);
																				} } />
																		</div>
																	</div>
																) : (
																	<div className="container-values-top">
																		<img src={ TimeIcon } />
																		<div>
																			<p className="bold">Hora</p> 
																			<p>{ moment(verification?.hour,'HH:mm:ss').format('HH:mm') }</p>
																		</div>
																	</div>
																)
															}
														</>
													)
												}
											</div>
										</div>

										{
											verification?.name && (
												<div className="container-name">
													<img src={ User2Icon } />
													<div>
														{
															is_edit ? (
																<div style={{ display: 'flex', marginBottom: '3px' }}>
																	<p><span className="bold">RAZÓN SOCIAL:</span></p>
																	<Input
																		value={ verification?.name }
																		name="name"
																		className="values-top"
																		onChange={ (e: any) => {
																			this.change(e);
																		} } />
																</div>
															) : (
																<p style={{ marginBottom: '3px' }}><span className="bold">Razón social:</span> { verification?.name }</p>
															)
														}
														{
															verification?.document && (
																<>
																	{
																		is_edit ? (
																			<div style={{ display: 'flex' }}>
																				<p><span className="bold">RIF/C.I.:</span></p>
																				<Input
																					value={ verification?.document }
																					name="document"
																					className="text-right values-top"
																					onChange={ (e: any) => {
																						this.change(e);
																					} } />
																			</div>
																		) : (
																			<p><span className="bold">RIF/C.I.:</span> { verification?.document }</p>
																		)
																	}
																</>
															)
														}
													</div>
												</div>
											)
										}
									</div>

									{
										(verification?.total > 0 || verification?.details?.length > 0) && (
											<div className="container-white">
												<h3>Detalle de productos</h3>
												{
													verification?.details?.length > 0 && (
														<div className="row">
															<div className="col-md-12 row-products">
																<div className="row">
																	<div className={ `col-md-9 bold value thead` }>Producto</div>
																	<div className="col-md-3 bold value text-right thead">Total</div>
																</div>
															</div>
															{
																verification?.details?.map((item: any,index: number) => {
																	const real_total = parseFloat((item.quantity * item.price).toFixed(2));
																	const is_diff = item.total != real_total;

																	return (
																		<div className="col-md-12 row-products">
																			<div className="row">
																				<div className={ `col-md-9 } value` }>
																					<div className="container-product">
																						<div className="container-index">
																							<p>{ index + 1 }</p>
																						</div>
																						<div>
																							{
																								is_edit ? (
																									<>
																										<Input
																											value={ item?.name }
																											name="name"
																											onChange={ (e: any) => {
																												this.changeDetail(e,index);
																											} } />
																										<div className="container-inputs-quantity">
																											<div style={{ maxWidth: '50px' }}>
																												<Input
																													type="decimal"
																													value={ item?.quantity }
																													name="price"
																													onChange={ (e: any) => {
																														this.changeDetail(e,index);
																													} } />
																											</div>
																											<p>x</p>
																											<Input
																												type="decimal"
																												value={ item?.price }
																												name="price"
																												onChange={ (e: any) => {
																													this.changeDetail(e,index);
																												} } />
																										</div>
																									</>
																								) : (
																									<>
																										<p>{ item.name }</p>
																										<p>{ item.quantity }x { Globals.formatMiles(item.price,true,verification?.currency) }</p>
																									</>
																								)
																							}
																							{
																								has_code && (
																									<>
																										{
																											is_edit ? (
																												<>
																													<Input
																														value={ item?.code }
																														name="code"
																														onChange={ (e: any) => {
																															this.changeDetail(e,index);
																														} } />
																												</>
																											) : (
																												<>
																													{ item.code }
																												</>
																											)
																										}
																									</>
																								)
																							}

																							{
																								is_diff && (
																									<p className="danger-message">Esperado: { Globals.formatMiles(real_total,true,verification?.currency) } - Diferencia: <span>{ Globals.formatMiles(item.total - real_total,true,verification?.currency) }</span></p>
																								)
																							}
																						</div>
																					</div>
																				</div>
																				<div className="col-md-3 value text-right">
																					{
																						is_edit ? (
																							<>
																								<Input
																									type="decimal"
																									value={ item?.total }
																									name="total"
																									className="text-right"
																									onChange={ (e: any) => {
																										this.changeDetail(e,index);
																									} } />
																							</>
																						) : (
																							<p className={ is_diff ? 'danger' : '' }>
																								{ Globals.formatMiles(item.total,true,verification?.currency) }
																								{
																									is_diff && (
																										<img src={ AlertCircleIcon } />
																									)
																								}
																							</p>
																						)
																					}
																				</div>
																			</div>
																		</div>
																	)
																})
															}
														</div>
													)
												}
												<div className="container-blue">
													<div className="row">
														{
															verification?.subtotal > 0 && (
																<>
																	<div className="col-md-6">
																		<p className="bold">SUBTOTAL</p>
																		{
																			is_diff_subtotal && (
																				<p className="danger-message">Esperado: { Globals.formatMiles(real_subtotal,true,verification?.currency) } - Diferencia: <span>{ Globals.formatMiles(verification?.subtotal - real_subtotal,true,verification?.currency) }</span></p>
																			)
																		}
																	</div>
																	<div className="col-md-6 text-right">
																		{
																			is_edit ? (
																				<Input
																					type="decimal"
																					value={ verification?.subtotal }
																					name="subtotal"
																					className="text-right"
																					onChange={ (e: any) => {
																						this.change(e);
																					} } />
																			) : (
																				<p className={ is_diff_subtotal ? 'danger' : '' }>
																					{ Globals.formatMiles(verification?.subtotal,true,verification?.currency) }
																					{
																						is_diff_subtotal && (
																							<img src={ AlertCircleIcon } />
																						)
																					}
																				</p>
																			)
																		}
																	</div>
																</>
															)
														}
														{
															verification?.iva > 0 && (
																<>
																	<div className="col-md-6">
																		<p className="bold">IVA</p>
																		{/*<p className="danger-message">El porcentaje calculado no coincide con el subtotal.</p>*/}
																	</div>
																	<div className="col-md-6 text-right">
																		{
																			is_edit ? (
																				<Input
																					type="decimal"
																					value={ verification?.iva }
																					name="iva"
																					className="text-right"
																					onChange={ (e: any) => {
																						this.change(e);
																					} } />
																			) : (
																				<p>
																					{ Globals.formatMiles(verification?.iva,true,verification?.currency) }
																					{/*<img src={ AlertCircleIcon } />*/}
																				</p>
																			)
																		}
																	</div>
																</>
															)
														}
														{
															verification?.igtf > 0 && (
																<>
																	<div className="col-md-6">
																		<p className="bold">IGTF</p>
																		{/*<p className="danger-message">El porcentaje calculado no coincide con el subtotal.</p>*/}
																	</div>
																	<div className="col-md-6 text-right">
																		{
																			is_edit ? (
																				<Input
																					type="decimal"
																					value={ verification?.igtf }
																					name="igtf"
																					className="text-right"
																					onChange={ (e: any) => {
																						this.change(e);
																					} } />
																			) : (
																				<p>
																					{ Globals.formatMiles(verification?.igtf,true,verification?.currency) }
																					{/*<img src={ AlertCircleIcon } />*/}
																				</p>
																			)
																		}
																	</div>
																</>
															)
														}
														<div className="col-md-12">
															<hr />
														</div>
														<div className="col-md-6">
															<p className="bold bold-blue">TOTAL</p>
															{
																is_diff_total && (
																	<>
																		<p className="danger-message">Esperado: { Globals.formatMiles(real_total,true,verification?.currency) } - Diferencia: <span>{ Globals.formatMiles(verification?.total - real_total,true,verification?.currency) }</span></p>
																		<p className="danger-message">La suma subtotal + IVA no coincide.</p>
																	</>
																)
															}
															
														</div>
														<div className="col-md-6 text-right">
															{
																is_edit ? (
																	<Input
																		type="decimal"
																		value={ verification?.total }
																		name="total"
																		className="text-right"
																		onChange={ (e: any) => {
																			this.change(e);
																		} } />
																) : (
																	<p className={ `bold bold-blue ${ is_diff_total ? 'danger' : '' }` }>
																		{ Globals.formatMiles(verification?.total,true,verification?.currency) }
																		{
																			is_diff_total && (
																				<img src={ AlertCircleIcon } />
																			)
																		}
																	</p>
																)
															}
														</div>
													</div>
												</div>

												{
													this.state.is_edit && (
														<div className="row">
															<div className="col-md-6 text-center">
																<button className="btn btn-cancel" onClick={ () => {
																	this.setState({
																		is_edit: !this.state.is_edit,
																		verification: this.state.original_verification
																	});
																} }>
																	Cancelar
																</button>
															</div>
															<div className="col-md-6 text-center">
																<button className="btn btn-save" onClick={ () => {
																	this.save();
																} }>
																	Guardar
																</button>
															</div>
														</div>
													)
												}

												{
													verification?.updated_by_id != null && (
														<div className="alert-container text-center" style={{ justifyContent: 'center', alignItems: 'center' }}>
															<img src={ AlertIcon } />
															<p>Modificado por { verification?.updated_by?.name } { verification?.updated_by?.lastname } - { moment(verification?.updated_at).format('DD/MM/YYYY HH:mm') }</p>
														</div>
													)
												}
											</div>
										)
									}
								</div>
							)
						}
					</div>
					{
						verification != null && (
							<div className="col-md-6">
								<div className="container-gray">
									<h3>Imagen escaneada</h3>
									{
										verification?.file != null && (
											<div className="text-center">
												<div className="container-image" onClick={ () => this.view(Globals.generateS3(verification?.file,true,verification?.s3_provider)) }>
													{
														verification?.file?.toLowerCase().endsWith('.pdf') ? (
															<div style={{
																width: '100%',
																height: '400px',
																overflow: 'hidden',
																border: '1px solid #ccc'
															}}>
																<iframe src={ `https://mozilla.github.io/pdf.js/web/viewer.html?file=${ Globals.generateS3(verification?.file,true,verification?.s3_provider) }` } style={{ border: 'none', width: '100%', height: '432px', marginTop: '-32px' }} />
															</div>
														) : (
															<img src={ Globals.generateS3(verification?.file,true,verification?.s3_provider) } />
														)
													}
												</div>
											</div>
										)
									}
								</div>

								<div className="container-white">
									<h3>Información adicional</h3>
									<div className="row row-info">
										<div className="col-md-6">
											<p>Intento</p>
										</div>
										<div className="col-md-6">
											<p className="blue">{ this.state.page } de { this.state.last_page }</p>
										</div>
									</div>
									<div className="row row-info">
										<div className="col-md-6">
											<p>Verificado el</p>
										</div>
										<div className="col-md-6">
											<p>{ moment(verification?.created_at).format('DD/MM/YYYY HH:mm') }</p>
										</div>
									</div>
								</div>
							</div>
						)
					}
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ViewVerification);